import { Typography, MenuItem, TextField, CircularProgress, Stack, Button, Box, FormControlLabel, Checkbox,  Dialog, DialogContent, DialogTitle, DialogActions, Backdrop, IconButton } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import React, {useEffect, useState, useContext, useMemo} from "react";
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { useNavigate } from "react-router-dom";
import { Context } from "../App";
import { API } from "../conf";
import moment from 'moment';
import Header from "../Components/layout/Header";
import PaymodeForm from "../Components/forms/pay-mode-form";
import { COMPTES_DE_CHARGES } from "../asset/variables";

export default function RegistDepense(props) {
    const navigate = useNavigate()
    const { updateConnect, exercice } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const [loading, setLoad] = useState(true)
    const [sending, setSend] = useState(false)
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState("")
    const [comptes, setComptes] = useState([])
    const [uncloture_months, setUncloture_months] = useState([])
    const [reptotal, setReptotal] = useState(props.depense?.paymode? (props.depense.paymode.especes+props.depense.paymode.cheques?.reduce((tt, cq)=>tt+cq.montant,0)+(props.depense.paymode.virement?.montant??0)+(props.depense.paymode.prelevement?.montant??0)):0)
    
    const [date, setDate] = useState(props.depense?.date? moment.utc(props.depense.date):null)
    const [compteNum, setCompte] = useState(props.depense?.comptes[0] || '')
    const [classe, setClasse] = useState(props.depense?.class??'')
    const [fournisseur, setFournisseur] = useState(props.depense?.fournisseur??'')
    const [label, setLabel] = useState(props.depense?.libelle??'')
    const [num_facture, setFactnum] = useState(props.depense?.num_facture??'')
    const [montant, setMontant] = useState(props.depense?.montant??0)
    const [facture_files, setFiles] = useState([''])
    const [banque, setBanque] = useState('')
    const [is_petite_caisse, setPetiteCaisse] = useState(false)
    
    const [pay_mode, setMode] = useState(props.depense?.paymode? Object.keys(props.depense?.paymode).filter(key=>{
        switch (key) {
            case 'especes':
                return props.depense.paymode.especes>0
            case 'cheques':
                return props.depense.paymode.cheques?.length>0
            case 'virement':
                return props.depense.paymode.virement?.montant>0
            case 'prelevement':
                return props.depense.paymode.prelevement?.montant>0
            default:
                return false
        }
    }):[''])
    const [especes, setEspeces] = useState(props.depense?.paymode?.especes??0)
    const [repCheques, setRepCheques] = useState(props.depense?.paymode?.cheques??[{banque:'', montant:0, num_cheque:''}])
    const [repVir, setRepVir] = useState(props.depense?.paymode?.virement?{...props.depense.paymode.virement, date: moment.utc(props.depense.paymode.virement.date).format('yyyy-MM-DD')}:{date:"", montant:0, ref: ''})
    const [repPrev, setRepPrev] = useState(props.depense?.paymode?.prelevement?{...props.depense.paymode.prelevement, date: moment.utc(props.depense.paymode.prelevement.date).format('yyyy-MM-DD')}:{date:"", montant:0, ref: ''})

    const eglise = useMemo(()=> props.eglise ? props.eglise : (organisation?.type==='église'?organisation:eglises.find(eg=>eg._id===(props.edit?props.depense?.eglise:egliseId))),[egliseId,eglises,organisation, props.edit,props.depense?.eglise, props.eglise])
    const compte = useMemo(()=>comptes.find(c=>c.num===compteNum),[compteNum, comptes])

    function manageDialog(opened, actionType="") {
        setAction(actionType)
        setOpen(opened)
    }

    async function getPetiteCaisseCompte() {
        setLoad(true)
        const query = new URLSearchParams({eglise: eglise.number, type: 'petite-caisse', exercice}).toString()
        const response = await fetch(API.concat(`/comptes/by?${query}`), {
            method:'GET',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        })
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
            sessionStorage.clear()
            updateConnect(false)
        }else {
            if (token && token !== sessionStorage.getItem('token') && token !== '') {
                sessionStorage.setItem('token', response.headers.get('x-auth-token'))
            }
            if (response.status === 200) {
                const petiteCaisseComptes = await response.json()
                setComptes(old=>[...old, ...petiteCaisseComptes])
                setLoad(false)
            }
        }
    }

    async function handleSubmit() {
        setSend(true)
        manageDialog(false)
        const pcCompte = comptes.find(cp=>cp.type==='petite-caisse')

        if (!pcCompte) {
            await getPetiteCaisseCompte()
            alert("Une erreur est survenue: aucun compte de petite caisse n'a été trouvé pour cette église. Veuillez réessayer.")
        } else {
            const depense = {
                date: date ? date.toISOString() : '',
                comptes: [
                    compteNum, 
                    banque, 
                    (is_petite_caisse||(agent.level<3&&especes>0)) ? pcCompte.num : ''
                ].filter(cpt=>cpt!==''),
                libelle: label,
                montant: montant,
                class: classe,
                fournisseur: fournisseur,
                num_facture: num_facture,
                paymode: JSON.stringify({
                    especes: especes,
                    cheques: repCheques.filter(cheque=> cheque.montant>0),
                    virement: repVir.montant>0 ? repVir : {},
                    prelevement: repPrev.montant>0 ? repPrev : {},
                }),
                eglise: eglise.number,
                exercice
            }
            let formdata = new FormData()
            for (let key in depense) {
                formdata.append(key, depense[key]);
            }
            const facture = facture_files.filter(f=> f!=='')
            for (let index = 0; index < facture.length; index++) {
                formdata.append('file', facture[index])
            }
            
            fetch(API.concat(props.edit? `/depenses/${props.depense?._id}/${JSON.stringify({montant: props.depense?.montant, especes: props.depense?.paymode?.especes, eglise: eglise.number, date: date ? date.toISOString() : ''})}`
                :`/depenses/create/${eglise._id}/${date ? date.year() : exercice}`), {
                method: props.edit? 'PATCH':'POST',
                headers:{'Authorization': 'Bearer ' + sessionStorage.getItem('token')},
                body: formdata
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.ok)  {
                        if (props.edit) {
                            const json = await response.json()
                            props.setDepenses(json)
                            props.close()
                        } else manageDialog(true, 'next')
                    } else {
                        const error = await response.text()
                        alert("Une erreur est survenue: "+error)
                    }
                    setSend(false)
                }
            })
        }
    }

    function handleImport(event, index) {
        event.preventDefault();
        if (event.target.files.length>0) {
            const file = event.target.files[0]
            if (!facture_files.some(f => f.name===file.name && f.size===file.size && f.lastModified===file.lastModified)) {
                setFiles(old => {let newFiles=[...old]; newFiles[index]=event.target.files[0]; return newFiles})            
            }
        }
    }

    useEffect(()=>{
        if(eglise) {
            setLoad(true)
            const query = new URLSearchParams({eglise: eglise.number, exercice}).toString()

            fetch(API.concat(`/eglise/clotures?isMonth=true&${query}`),{
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const clotures = await response.json()
                        const currentMonth =exercice< new Date().getFullYear() ? 11 : new Date().getMonth(); // 0 indexed (janvier = 0)
                       
                        if (clotures.length>0) {
                            const months = Array.from({ length: currentMonth + 1 }, (_, i) => i)
                                .filter(month=>!clotures.some(cloture=>new Date(cloture.date).getMonth()===month))
                                // setUncloture_months(months.length>2?months.slice(0,2):months)
                                setUncloture_months(months)
                        }else {
                            const months = Array.from({ length: currentMonth + 1 }, (_, i) => i)
                            setUncloture_months(months)
                        }
                    }
                }
            })

            fetch(API.concat(`/comptes/by?${query}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const comptes = await response.json()
                        setComptes(comptes); 
                        setLoad(false)
                    }
                }
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eglise])

    useEffect(()=>{
        if (organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    },[agent,organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])

    const comptes_filter = ['banque', 'petite-caisse',(agent?.level<3? 'liaison': '')].filter(e=>e!=='')
    
    return(
        <Box sx={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            {!props.edit&&<Header/>}
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Enregistrement des dépenses</Typography>
            {organisation.type==='fédération'&&!props.edit&&<TextField select size="small" label='Église' sx={{minWidth:'300px', width:'20%', alignSelf:'end', marginRight:3}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(item=><MenuItem key={item._id} value={item._id}>{item.nom} - {item.commune.toUpperCase()}</MenuItem>)}
            </TextField>}

            {eglise&&<Box component='form' onSubmit={e=>{ e.preventDefault(); manageDialog(true, 'confirm')}}
            sx={{paddingX:'20px', marginTop:'20px', display:"flex", flexDirection:'column', width:'70%', minWidth:'500px', alignSelf:'center'}}>
                <Stack spacing={2}>
                    <Stack direction='row' sx={{justifyContent:'space-between', alignItems:'baseline'}} >
                        <TextField
                        variant="standard"
                        required
                        sx={{width:'60%', minWidth:'250px'}}
                        label="Libellé"
                        value={label}
                        onChange={(e)=>setLabel(e.target.value)}/>

                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Date"
                                value={date}
                                disabled={uncloture_months.length === 0}
                                minDate={moment().year(exercice).month(0).date(1)}
                                maxDate={moment().isBefore(moment().year(exercice).month(11).date(31)) ? moment() : moment().year(exercice).month(11).date(31)}
                                shouldDisableDate={(date) => {
                                    if (!date) return true;
                                    const selectedYear = date.year();
                                    const selectedMonth = date.month();
                                    return selectedYear !== exercice || !uncloture_months.includes(selectedMonth);
                                }}
                                onChange={(newValue) => {
                                    if (newValue && newValue.isValid()) {
                                        const selectedMonth = newValue.month();
                                        if (newValue.year() === exercice && uncloture_months.includes(selectedMonth)) {
                                            setDate(newValue);
                                        }
                                    }
                                }}
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        required: true
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Stack>

                    <Stack direction='row' spacing={2}>
                        <TextField
                        id="outlined-select-currency"
                        fullWidth
                        required
                        select
                        label="Classification"
                        value={classe}
                        onChange={(event)=> setClasse(event.target.value)}
                        >
                            {COMPTES_DE_CHARGES.sort((a, b) => a.libelle.localeCompare(b.libelle)).map((item, index) => (
                                <MenuItem key={index} value={item.libelle}>
                                    <Typography sx={{}}>{item.libelle}</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                        fullWidth
                        margin="normal"
                        label="Fournisseur"
                        value={fournisseur}
                        onChange={(e)=>setFournisseur(e.target.value)}/>
                    </Stack>
                    
                    <Stack direction='row' spacing={2}>
                        <TextField required fullWidth select label="Compte à débiter" value={compteNum} id="outlined-select-currency"
                        slotProps={{ select: { renderValue: ()=>{
                            const compte = comptes.find(c=>c.num===compteNum)??''
                            return <Typography sx={{lineHeight: 1}}>{compte.libelle}<br/><span style={{fontSize:12, color:'grey'}}>compte n°{compte.num_compte}</span></Typography>
                        }}}}
                        onChange={(event)=> setCompte(event.target.value)}
                        >
                            {loading ?
                            <Box display='flex' justifyContent='center' alignItems='center'>
                                <CircularProgress />
                            </Box>
                            :comptes.filter(cp=>!comptes_filter.includes(cp.type)).map((compte, index) => (
                                <MenuItem key={index} value={compte.num} sx={{justifyContent:'space-between', py:1}}>
                                    <Typography sx={{lineHeight: 1, textTransform:'capitalize'}}>{compte.libelle}<br/><span style={{fontSize:12, color:'grey'}}>compte n°{compte.num_compte}</span></Typography> 
                                    <Typography sx={{textTransform:'capitalize'}}>{compte.solde?.toFixed(2)}€</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField type="number" required fullWidth name="montant" label="Montant (en €)"
                        slotProps={{ htmlInput: { min:'0', step:'0.01'} }}
                        onFocus={()=>{if(montant===0) setMontant('')}} onBlur={()=> {if(montant==='') setMontant(0)}}
                        value={montant}
                        onChange={(e)=>{
                            // Remplacer la virgule par un point pour le format nombre anglais
                            const normalizedValue = e.target.value.replace(',', '.');
                            if (/^\d+([.,]\d{1,2})?$/.test(e.target.value)&&Number(normalizedValue)>=0){
                                setMontant(Number(normalizedValue))
                            }else if(e.target.value===''){
                                setMontant('')
                            }
                        }}/>
                    </Stack>
                </Stack>
                
                {montant>0 && <PaymodeForm 
                isdepense={true}
                total={montant}
                reptotal={reptotal}
                setReptotal={setReptotal}
                pay_mode={pay_mode}
                setMode={setMode}
                especes={especes}
                setEspeces={setEspeces}
                repCheques={repCheques}
                setRepCheques={setRepCheques}
                repVir={repVir}
                setRepVir={setRepVir}
                {...{repPrev, setRepPrev, have_banque: Boolean(eglise?.have_banque)}} />}

                <TextField
                sx={{width:'30%', minWidth:'150px'}}
                margin="normal"
                label="N° Facture"
                value={num_facture}
                onChange={(e)=>setFactnum(e.target.value)}/>  
                <Typography variant="subtitle1" sx={{marginTop:'20px', marginBottom:'10px'}}>Importer la Facture</Typography>
                {facture_files.map((file, index)=>(
                    <Stack key={index} direction={'row'} spacing={2} alignItems={'center'}>
                        <input type='file' name='facture_file' accept='.pdf' onChange={(event)=>{
                            handleImport(event, index)
                        }} />
                        <IconButton onClick={()=>setFiles(old=>{let newf=[...old]; newf.splice(index, 1); return newf})}><ClearIcon /></IconButton>
                    </Stack>
                ))}
                {facture_files[facture_files.length-1]!=='' && facture_files.length<5 &&
                <Button variant="contained" sx={{alignSelf:'flex-start', marginLeft:'20px', marginTop:'10px', textTransform:'none', fontWeight:'bold'}} startIcon={<AddIcon/>} color="grey" 
                onClick={()=>setFiles(old=>{let newf=[...old]; newf.push(''); return newf})}>
                    Ajouter un fichier
                </Button>}

                {agent.level>2&&<>
                    <Typography>Si cette dépense n’a pas été réglée par la FEAM veuillez préciser l’origine des fonds:</Typography>
                    <FormControlLabel control={<Checkbox checked={is_petite_caisse} onChange={()=>setPetiteCaisse(old=>!old)} />} label="petite caisse église" />
                    {eglise.have_banque&&pay_mode.some(key=>['cheques', 'virement', 'cb', 'prelevement'].includes(key))&&
                    <TextField select label="Banque église" value={banque} onChange={(e)=>setBanque(e.target.value)} sx={{marginTop:2}}>
                        {comptes.filter(cp=>cp.type==='banque').map(banque=><MenuItem key={banque.num} value={banque.num}>{banque.libelle}</MenuItem>)}
                    </TextField>}
                </>}

                <Button type="submit" variant="contained"
                disabled={montant!==reptotal || montant<=0}
                sx={{ alignSelf:'flex-end', marginRight:'30px', marginTop:'15px', fontWeight:'bold' }}>
                    Valider
                </Button>
            </Box>}

            <Dialog open={open} onClose={()=>action==="next" ? navigate("/") : manageDialog(false)}>
                {action==='confirm'&&<DialogContent>
                    <DialogTitle>Vous allez enregistrer la dépense suivante: </DialogTitle>
                    <DialogContent>
                        <Typography>Date: {date ? date.format('DD/MM/YYYY') : ''}</Typography>
                        <Typography textTransform={'capitalize'}>Libellé: {label}</Typography>
                        <Typography>Compte débité: {compte.num_compte} {compte.libelle}</Typography>
                        <Typography>Montant de la dépense: {montant?.toFixed(2)}€</Typography>
                        <Typography>Mode de paiement:</Typography>
                        {especes>0 && <Typography>Espèces: {especes?.toFixed(2)}</Typography>}
                        {repCheques.filter(cheque => cheque.montant>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                            <Typography>Chèques:</Typography>
                            {repCheques.filter(cheque => cheque.montant>0).map((cheque, index)=>
                                <Typography key={index} sx={{marginLeft: '20px'}}>chèque {cheque.banque} n°{cheque.num_cheque !== '' ? cheque.num_cheque : '_______'} de {cheque.montant?.toFixed(2)}€</Typography>)}
                        </Stack>}
                        {repVir.montant>0 && <Typography sx={{marginLeft: '30px'}}>Virment du {repVir.date!== '' ? moment.utc(repVir.date).format('DD/MM/YYYY') : '_______'} référencé 
                        {repVir.ref !== '' ? ` ${repVir.ref}` : ' _______'} de {repVir.montant?.toFixed(2)}€</Typography>}
                        {facture_files.some(file => file!=='') ? 
                        <>
                            <Typography sx={{marginTop:'10px'}}>Facture:</Typography> 
                            {facture_files.filter(file => file!=='').map((file, index)=>(
                                <Typography key={index} fontSize={14} sx={{marginLeft:'15px'}}>{file.name}</Typography>
                            ))}
                        </> 
                        :<Typography textAlign='center' sx={{marginTop:'5px'}} color='carmine.main' fontSize={14}><span style={{fontWeight:'bold', fontSize:16}}>Attention!</span><br/>
                        Vous n'avez pas joint de facture pour cette dépense</Typography>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>manageDialog(false)}>Annuler</Button>
                        <Button onClick={handleSubmit}>Confirmer</Button>
                    </DialogActions>
                </DialogContent>}

                {action==='next'&&<DialogContent>
                    <DialogTitle>La dépense a bien été enregistrée</DialogTitle>
                    <DialogActions>
                    <Button onClick={()=>window.location.reload()}>Enregistrer une autre dépense</Button>
                        <Button href="/">Accueil</Button>
                    </DialogActions>
                </DialogContent>}
            </Dialog>

            <Backdrop open={sending}><CircularProgress color="inherit" /></Backdrop>
        </Box >
    )
}